import React from "react";
import { Link, useLocation } from "react-router-dom";

  const Nav = ({generalApi}) => {

  const location = useLocation();
  const isActive = (url) => location.pathname === url;
  
  return (
    <div className="main-menu text-center">
      <nav>
        <ul className="main-menu__list">
          <li className={`dropdown ${isActive('/') ? 'current' : ''}`}>
            <Link to={process.env.PUBLIC_URL + `/`}>Home</Link>
          </li>
          <li className={`dropdown ${isActive('/about') ? 'current' : ''}`}>
            <Link to={process.env.PUBLIC_URL + `/about`}>About Us</Link>
            <ul>
              <li className={isActive('/about#what-we-do') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/about/#what-we-do`}>
                  What We Do
                </Link>
              </li>
              <li className={isActive('/about#management-team') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/about/#management-team`}>
                  Management Team
                </Link>
              </li>
            </ul>
          </li>

          <li className={`dropdown ${isActive('/what-we-do') ? 'current' : ''}`}>
            <Link to={process.env.PUBLIC_URL + `/what-we-do`}>What We Do</Link>
            <ul style={{width:'300px'}}>
              <li className={isActive('/what-we-do#entertainment') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/what-we-do#entertainment`}>
                  Entertainment and Culture
                </Link>
              </li>
              <li className={isActive('/what-we-do#branding') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/what-we-do#branding`}>
                  Branding and Advertising
                </Link>
              </li>
              <li className={isActive('/what-we-do#automobile') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/what-we-do#automobile`}>
                  Automobile Purchase / Sales
                </Link>
              </li>
              <li className={isActive('/what-we-do#tourist') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/what-we-do#tourism`}>
                  Tourist Services
                </Link>
              </li>
            </ul>
          </li>

          <li className={`dropdown ${isActive('/projects') ? 'current' : ''}`}>
            <Link to={process.env.PUBLIC_URL + `/projects`}>Projects</Link>
            <ul>
              <li className={isActive('/projects') ? 'current' : ''}>
                <Link to={process.env.PUBLIC_URL + `/projects#concept-transformation`}>
                  Heroes of Tomorrow
                </Link>
              </li>
            </ul>
          </li>

          <li className={isActive('/contact') ? 'current' : ''}>
            <Link to={process.env.PUBLIC_URL + `/contact`}>Contact Us</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
};

export default Nav;
